// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"145":"spacedetails","498":"bookonline","862":"booking","999":"bookingdetails"}[chunkId] + "." + {"145":"d0a1602e","498":"9cd7d43e","862":"20ac56dd","999":"40dd95cb"}[chunkId] + ".css";
};